import { createFileRoute } from '@tanstack/react-router'
import { Blog } from '@/components/blog/Blog.tsx'
import { getBlogs } from '@/components/blog/serverFn.ts'

export const Route = createFileRoute('/blog/$url/')({
	head: ({ loaderData: { blog } }) =>
		blog
			? [{ title: blog.metaTitle }, { name: 'description', content: blog.metaDescription }, { name: 'keywords', content: blog.metaKeywords }]
			: [
					{ title: 'WellView Care | Blog | Non-Profit Healthcare Organization' },
					{
						name: 'description',
						content:
							'Discover WellView Care, a 501(c)(3) Non-Profit Organization dedicated to healthcare equity, HIV eradication, and Hepatitis C treatment. Learn about our mission and commitment to comprehensive care for all.',
					},
					{
						name: 'keywords',
						content: 'Non-Profit Healthcare, HIV Eradication, Hepatitis C Treatment, PrEP Services, Healthcare Equity',
					},
				],
	loader: async ({ params }) => await getBlogs({ data: { url: params.url } }),
	component: RouteComponent,
})

function RouteComponent() {
	const { blogs, blog } = Route.useLoaderData()
	return <Blog blog={blog} suggestions={blogs || []} />
}
